import React from "react";
import { Tooltip } from "antd";
import moment from "moment";

export default function CommentDate({ event: propsEvent }) {

  function calculateDifferentTime() {
    // const newTime = moment(item.changedAt)
    const duration = moment(propsEvent.createdAt).fromNow()

    if (duration.includes('months') || duration.includes('month') || duration.includes('year') || duration.includes('years')) {
        return moment(propsEvent.createdAt).format("YYYY-MM-DD HH:mm:ss");;
    }

    return duration;
}

  return propsEvent.lastUpdated !== propsEvent.createdAt ? (
    <Tooltip
      title={moment(propsEvent.lastUpdated).format("YYYY-MM-DD HH:mm:ss")}
    >
      <span>
        Edited
        {" "}
        {moment(propsEvent.lastUpdated).fromNow()}
      </span>
    </Tooltip>
  ) : (
    <Tooltip title={moment(propsEvent.createdAt).format("YYYY-MM-DD HH:mm:ss")}>
      <span>{calculateDifferentTime()}</span>
    </Tooltip>
  );
}
